import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import ColorPaymentDay from "@/components/functionals/ColorPaymentDay.vue";
export default [
  {
    prop: "Clasification",
    name: "Clasification",
    label: "Clasification",
    align: "center",
    width: 130,
    formatter: ColorType,
    sortable: true
  },
  {
    prop: "ClientCode",
    name: "Codigo",
    label: "Codigo",
    width: 130,
    sortable: true
  },
  {
    prop: "Name",
    name: "Nombre",
    label: "Nombre",
    minWidth: 420,
    formatter: ImagePerson,
    sortable: true
  },
  {
    prop: "DealsCount",
    name: "Negotiations",
    label: "Negociaciones",
    width: 150,
    sortable: true,
    align: "center"
  },
  {
    prop: "SalesPersonName",
    name: "Vendedor",
    label: "Vendedor",
    minWidth: 220,
    formatter: ImagePerson,
    attrs: {
      imgKey: "SalesPersonPhoto"
    },
    sortable: true
  },
  {
    prop: "Email",
    name: "Email",
    label: "Email",
    minWidth: 300,
    sortable: true
  },

  {
    prop: "ClientType",
    name: "Tipo",
    label: "Tipo",
    width: 150,
    sortable: true
  },
  {
    prop: "Status",
    name: "Estado",
    label: "Estado",
    width: 130,
    sortable: true
  },
  {
    prop: "PaymentDay",
    name: "Dias de pagos",
    label: "Dias de pagos",
    align: "center",
    width: 150,
    formatter: ColorPaymentDay,
    sortable: true
  },

  {
    prop: "CustomerService",
    name: "Servicio",
    label: "Servicio",
    minWidth: 220,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CustomerServiceImage"
    },
    sortable: true
  },
  {
    prop: "AccountReceivable",
    name: "Cobros",
    label: "Agente de Cobros",
    minWidth: 220,
    formatter: ImagePerson,
    attrs: {
      imgKey: "AgentPhoto"
    },
    sortable: true
  },
  {
    prop: "EmployeesQuantity",
    name: "No. Empleados",
    label: "No. Empleados",
    minWidth: 220,
    sortable: true
  },
  {
    prop: "PcQuantity",
    name: "No. PC",
    label: "No. PC",
    minWidth: 220,
    sortable: true
  },
  {
    prop: "VehiclesQuantity",
    name: "No. Vehículos",
    label: "No. Vehículos",
    minWidth: 220,
    sortable: true
  },
  {
    prop: "ClientQuantity",
    label: "No. Clientes",
    minWidth: 220,
    sortable: true
  },
  {
    prop: "WebPage",
    name: "Página Web",
    label: "Página Web",
    minWidth: 220,
    sortable: true
  }
];
